import styled, { css } from 'styled-components'

const StyledRichTextInput = styled.div`
  ${props =>
    props.isDisabled
      ? css`
          min-height: 0;
          height: unset;
          padding: 1px 0.5rem;
          color: rgba(0, 0, 0, 0.25);
          background-color: #f5f5f5;
          cursor: not-allowed;
          border: 1px solid #d9d9d9;
          border-radius: 4px;
          line-height: 21px;
        `
      : css`
          min-height: 0;
          height: unset;
          padding: 1px 0.5rem;
        `};
  ${props =>
    props.isReadOnly &&
    css`
      outline: none;
      border: none;
      background-color: transparent;

      &:hover,
      &:focus {
        outline: none;
      }
    `};
  ${props =>
    props.isFocused &&
    css`
      border-color: #40a9ff;
      outline: 0;
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    `};
`

export default StyledRichTextInput
